import { AmazonLoginProvider, SocialAuthService } from '@abacritt/angularx-social-login';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { FacebookAuthProvider, GoogleAuthProvider } from 'firebase/auth';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/features/services/auth/auth.service';
import { MyErrorStateMatcher } from 'src/app/shared/app-classes';
import { InternationalizationService } from 'src/app/shared/services/internationalization.service';
import { LoggingService } from 'src/app/shared/services/Logging.service';
import { ToolsService } from 'src/app/shared/services/tools.service';

@Component({
  selector: 'app-register-part1',
  templateUrl: './register-part1.component.html',
  styleUrls: ['./register-part1.component.scss']
})
export class RegisterPart1Component {
  userDetailForm!: FormGroup;
  isConnected!: boolean;
  disabled: boolean=true;
  IsAdded: boolean=false;
  user :any ;
  subUser : any;
  productId = "free_product";
  show :any ;
  submitted :any ;
  @Input() count = false;
  @Output() update = new EventEmitter<any>();
  platforms=[
    {"viewValue": "Custom", "value":"custom"},
    {"viewValue": "Shopify", "value":"shopify"},
    {"viewValue": "Woocommerce", "value":"woocommerce"},
  ]
  activities=[
    {"viewValue": "E-commerce", "value":"e-commerce"},
    {"viewValue": "Other", "value":"other"},
  ]
  countries: any;
  matcher = new MyErrorStateMatcher();
  accptterms :any;
  accept :any ;
  userAlreadyExist: any;
  constructor(private  auth: AuthService,
    //private cos: CommunicationService,
    private afs: AngularFirestore,
    private tools:ToolsService,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    private Inter: InternationalizationService,
    public  snackBar: MatSnackBar,
    private loggingService: LoggingService
  ) {
      this.titleService.setTitle( 'Sign up' );
      this.userDetailForm = new FormGroup({
        password: new FormControl('',[Validators.required, Validators.minLength(8)]),
        confirm_password: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required, Validators.email]),
        accept: new FormControl(''),
      });
    }

    ngOnInit() {
      this.countries=this.Inter.getAllCountry();
      this.auth.getUser()?.subscribe(
        (u:any) => {
          if (this.tools.isNullOrUndefined(u)) {
            this.isConnected = false;
          } else {
            this.isConnected = true;
            this.userDetailForm.setValue({
              name: u.displayName,
              email: u.email,
              cell: u.cell,
              company: u.gender,
              });
              //this.cos.sendUserConnected(u)
  
          }
        });
    
    }
    async registerClient() {
      const email = this.userDetailForm.controls['email'].value;
      const password = this.userDetailForm.controls['password'].value;
      const password2 = this.userDetailForm.controls['confirm_password'].value;
      if(this.userDetailForm.valid && (password === password2) ){
      this.route.params.subscribe(async params => {
            try {
              const response = await this.auth.SignUpWithEmail(email, password)
              this.auth.SendVerificationMail(email)
              this.router.navigate(['/auth/signup-details']);
            }catch (error) {
              this.userAlreadyExist = "The email address is already in use by another account. (auth/email-already-in-use)."
            }
                this.count = true;
                this.update.emit({
                  count: this.count
                });
          // } 
        
      });
    }
    }
  
    doLogin() {
      this.auth.redirectRouteSnapshot = this.route.snapshot;
      this.router.navigate(['auth/login']);
    }
    
    Iaccept(event:any)
    {
      this.disabled = false
      this.loggingService.log('this.disabled' , event)
    }
    signInWithGoogle()
    {this.loggingService.log('test')
      this.auth.AuthLogin(new GoogleAuthProvider()).then(
        (res) => {
          this.auth.SetUserData(res.user,'gmail')
          this.router.navigate(['/auth/signup-details']);
        },
        (err) => {
          this.loggingService.log('signup failed')
        }
      )
    }
    signInWithFB()
    {
      this.auth.AuthLogin(new FacebookAuthProvider()).then(
        (res) => {
          //this.auth.checkAccountEmailExistInFirebase(res.user.email)
          this.auth.SetUserData(res.user,'facebook')
          this.router.navigate(['/auth/signup-details']);
        },
        (err) => {
          this.loggingService.log('signup failed')
        }
      )
    }
    hidepass = true;
    hidepass2 = true;
    signInWithAmazon(){
      // this.authService.signIn(AmazonLoginProvider.PROVIDER_ID).then( 
      //    async (res) => {

      //    const userExit = await this.auth.checkAccountEmailExistInFirebase(res.email)
      //     if (  userExit === true )
      //     {
      //       this.auth.doTokenLogin(res.authToken)
      //       this.auth.SetUserDataAmazon(res)
      //       this.router.navigate(['/auth/signup-details']);
      //     }else 
      //     {
      //       this.snackBar.open('User alredy exist ', '', { duration: 4000 });
      //     }
      // },
      // (err) => {
      //   this.loggingService.log('signup failed' , err)
      //   this.loggingService.log('signup failed')
      // })
    }
}
